module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-easter-left-35f512429295f9ad7ec1885e67058af0.svg";